import React, { useState } from 'react';
import { PageHeader } from '../components/dashboard/PageHeader';
import { Card, CardContent } from '../components/Card';
import { Tabs, TabsList, TabsTrigger, TabsContent } from '../components/Tabs';
import { Button } from '../components/Button';
import { Label } from '../components/Label';
import { Input } from '../components/Input';
import { Checkbox } from '../components/Checkbox';
import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../components/Select';
import { Separator } from '../components/Separator';
import { Badge } from '../components/Badge';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../components/Dialog';
import { Settings as SettingsIcon, Bell, Shield, Database, Palette, Languages, KeyRound, Save, Smartphone, Key as KeyIcon, MessageSquare, QrCode } from 'lucide-react';
import { toast } from 'sonner';
export function Settings() {
  const [notifEmail, setNotifEmail] = useState(true);
  const [notifSms, setNotifSms] = useState(true);
  const [notifPush, setNotifPush] = useState(true);
  const [notifDaily, setNotifDaily] = useState(true);
  const [autoRefresh, setAutoRefresh] = useState('30');
  const [language, setLanguage] = useState('id');
  const [density, setDensity] = useState('comfortable');
  const [mfaDialogOpen, setMfaDialogOpen] = useState(false);
  const [mfaDeviceType, setMfaDeviceType] = useState<'hardware' | 'authenticator' | 'sms'>('authenticator');
  const [mfaCode, setMfaCode] = useState('');
  const save = (section: string) => toast.success(`Pengaturan ${section} disimpan`, {
    description: 'Perubahan diterapkan untuk sesi ini.'
  });
  const handleVerifyMfa = () => {
    if (mfaCode.length !== 6) {
      toast.error('Kode verifikasi harus 6 digit');
      return;
    }
    toast.success('Perangkat MFA baru berhasil didaftarkan', {
      description: `Tipe: ${mfaDeviceType === 'hardware' ? 'Hardware Token' : mfaDeviceType === 'authenticator' ? 'Authenticator App' : 'SMS Backup'}`
    });
    setMfaCode('');
    setMfaDialogOpen(false);
  };
  return <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6" data-id="element-3209">
      <PageHeader group="Sistem" title="Pengaturan Sistem" description="Kelola preferensi tampilan, notifikasi, keamanan akun, dan integrasi sumber data." icon={SettingsIcon} data-id="element-3210" />

      <Tabs defaultValue="profile" data-id="element-3211">
        <TabsList className="bg-card border border-border/50 p-1" data-id="element-3212">
          <TabsTrigger value="profile" data-id="element-3213">Profil & Akun</TabsTrigger>
          <TabsTrigger value="notifications" data-id="element-3214">Notifikasi</TabsTrigger>
          <TabsTrigger value="security" data-id="element-3215">Keamanan</TabsTrigger>
          <TabsTrigger value="appearance" data-id="element-3216">Tampilan</TabsTrigger>
          <TabsTrigger value="data" data-id="element-3217">Sumber Data</TabsTrigger>
        </TabsList>

        {/* PROFILE */}
        <TabsContent value="profile" className="mt-4" data-id="element-3218">
          <Card className="bg-card border-border/50" data-id="element-3219">
            <CardContent className="p-6 space-y-5" data-id="element-3220">
              <div data-id="element-3221">
                <h3 className="font-heading text-base font-bold" data-id="element-3222">
                  Informasi Akun
                </h3>
                <p className="text-xs text-muted-foreground mt-0.5" data-id="element-3223">
                  Detail akun pengguna yang tercatat di BSSN.
                </p>
              </div>
              <Separator data-id="element-3224" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-3225">
                <div data-id="element-3226">
                  <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3227">
                    Nama Lengkap
                  </Label>
                  <Input defaultValue="Presiden Republik Indonesia" className="mt-1.5" data-id="element-3228" />
                </div>
                <div data-id="element-3229">
                  <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3230">
                    NIP / ID
                  </Label>
                  <Input defaultValue="VVIP-01-2026" disabled className="mt-1.5" data-id="element-3231" />
                </div>
                <div data-id="element-3232">
                  <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3233">
                    Email Resmi
                  </Label>
                  <Input defaultValue="presiden.ri@gov.id" className="mt-1.5" data-id="element-3234" />
                </div>
                <div data-id="element-3235">
                  <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3236">
                    Telepon
                  </Label>
                  <Input defaultValue="+62 21 3811 1111" className="mt-1.5" data-id="element-3237" />
                </div>
                <div data-id="element-3238">
                  <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3239">
                    Bahasa
                  </Label>
                  <Select value={language} onValueChange={setLanguage} data-id="element-3240">
                    <SelectTrigger className="mt-1.5" data-id="element-3241">
                      <SelectValue data-id="element-3242" />
                    </SelectTrigger>
                    <SelectContent data-id="element-3243">
                      <SelectItem value="id" data-id="element-3244">Bahasa Indonesia</SelectItem>
                      <SelectItem value="en" data-id="element-3245">English</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div data-id="element-3246">
                  <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3247">
                    Zona Waktu
                  </Label>
                  <Select defaultValue="wib" data-id="element-3248">
                    <SelectTrigger className="mt-1.5" data-id="element-3249">
                      <SelectValue data-id="element-3250" />
                    </SelectTrigger>
                    <SelectContent data-id="element-3251">
                      <SelectItem value="wib" data-id="element-3252">WIB (UTC+7)</SelectItem>
                      <SelectItem value="wita" data-id="element-3253">WITA (UTC+8)</SelectItem>
                      <SelectItem value="wit" data-id="element-3254">WIT (UTC+9)</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-3255">
                <Button onClick={() => save('profil')} data-id="element-3256">
                  <Save className="size-4 mr-1.5" data-id="element-3257" /> Simpan Profil
                </Button>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* NOTIFICATIONS */}
        <TabsContent value="notifications" className="mt-4" data-id="element-3258">
          <Card className="bg-card border-border/50" data-id="element-3259">
            <CardContent className="p-6 space-y-5" data-id="element-3260">
              <div data-id="element-3261">
                <h3 className="font-heading text-base font-bold flex items-center gap-2" data-id="element-3262">
                  <Bell className="size-4 text-primary" data-id="element-3263" /> Preferensi Notifikasi
                </h3>
                <p className="text-xs text-muted-foreground mt-0.5" data-id="element-3264">
                  Pilih kanal pengiriman untuk peringatan dan ringkasan.
                </p>
              </div>
              <Separator data-id="element-3265" />
              <div className="space-y-3" data-id="element-3266">
                {[{
                key: 'email',
                label: 'Email',
                desc: 'Briefing harian & escalation kritis',
                checked: notifEmail,
                setter: setNotifEmail
              }, {
                key: 'sms',
                label: 'SMS',
                desc: 'Hanya untuk threat level CRITICAL',
                checked: notifSms,
                setter: setNotifSms
              }, {
                key: 'push',
                label: 'Push Notification',
                desc: 'Aplikasi GARUDA mobile (iOS/Android)',
                checked: notifPush,
                setter: setNotifPush
              }, {
                key: 'daily',
                label: 'Daily Brief 06:00 WIB',
                desc: 'Ringkasan otomatis setiap pagi',
                checked: notifDaily,
                setter: setNotifDaily
              }].map(r => <label key={r.key} className="flex items-start gap-3 p-3 rounded-lg border border-border/50 bg-muted/20 hover:bg-muted/40 transition cursor-pointer" data-id="element-3267">
                    <Checkbox checked={r.checked} onCheckedChange={(v: any) => r.setter(!!v)} className="mt-0.5" data-id="element-3268" />
                    <div className="flex-1" data-id="element-3269">
                      <p className="text-sm font-medium" data-id="element-3270">{r.label}</p>
                      <p className="text-xs text-muted-foreground" data-id="element-3271">{r.desc}</p>
                    </div>
                  </label>)}
              </div>
              <div className="flex justify-end" data-id="element-3272">
                <Button onClick={() => save('notifikasi')} data-id="element-3273">
                  <Save className="size-4 mr-1.5" data-id="element-3274" /> Simpan Preferensi
                </Button>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* SECURITY */}
        <TabsContent value="security" className="mt-4" data-id="element-3275">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-3276">
            <Card className="bg-card border-border/50" data-id="element-3277">
              <CardContent className="p-6 space-y-4" data-id="element-3278">
                <div data-id="element-3279">
                  <h3 className="font-heading text-base font-bold flex items-center gap-2" data-id="element-3280">
                    <KeyRound className="size-4 text-primary" data-id="element-3281" /> Ubah Password
                  </h3>
                  <p className="text-xs text-muted-foreground mt-0.5" data-id="element-3282">
                    Wajib diperbarui setiap 90 hari sesuai kebijakan BSSN.
                  </p>
                </div>
                <Separator data-id="element-3283" />
                <div className="space-y-3" data-id="element-3284">
                  <div data-id="element-3285">
                    <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3286">
                      Password Saat Ini
                    </Label>
                    <Input type="password" placeholder="••••••••" className="mt-1.5" data-id="element-3287" />
                  </div>
                  <div data-id="element-3288">
                    <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3289">
                      Password Baru
                    </Label>
                    <Input type="password" placeholder="••••••••" className="mt-1.5" data-id="element-3290" />
                  </div>
                  <div data-id="element-3291">
                    <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3292">
                      Konfirmasi Password
                    </Label>
                    <Input type="password" placeholder="••••••••" className="mt-1.5" data-id="element-3293" />
                  </div>
                </div>
                <Button onClick={() => save('password')} className="w-full" data-id="element-3294">
                  <Save className="size-4 mr-1.5" data-id="element-3295" /> Perbarui Password
                </Button>
              </CardContent>
            </Card>

            <Card className="bg-card border-border/50" data-id="element-3296">
              <CardContent className="p-6 space-y-4" data-id="element-3297">
                <div data-id="element-3298">
                  <h3 className="font-heading text-base font-bold flex items-center gap-2" data-id="element-3299">
                    <Shield className="size-4 text-primary" data-id="element-3300" /> Multi-Factor Auth
                  </h3>
                  <p className="text-xs text-muted-foreground mt-0.5" data-id="element-3301">
                    Perangkat MFA aktif untuk akun Anda.
                  </p>
                </div>
                <Separator data-id="element-3302" />
                <div className="space-y-2" data-id="element-3303">
                  {[{
                  label: 'YubiKey 5C NFC',
                  meta: 'Terdaftar 12 Mei 2026',
                  status: 'AKTIF'
                }, {
                  label: 'Authenticator App',
                  meta: 'iPhone 15 Pro · iOS 18',
                  status: 'AKTIF'
                }, {
                  label: 'SMS Backup',
                  meta: '+62 ••• 1111',
                  status: 'STANDBY'
                }].map(d => <div key={d.label} className="flex items-center justify-between p-3 rounded-lg border border-border/50 bg-muted/20" data-id="element-3304">
                      <div data-id="element-3305">
                        <p className="text-sm font-medium" data-id="element-3306">{d.label}</p>
                        <p className="font-mono text-[10px] text-muted-foreground" data-id="element-3307">
                          {d.meta}
                        </p>
                      </div>
                      <Badge variant="outline" className={d.status === 'AKTIF' ? 'bg-emerald-50 text-emerald-700 border-emerald-200 font-mono text-[10px]' : 'bg-muted text-muted-foreground border-border font-mono text-[10px]'} data-id="element-3308">
                        {d.status}
                      </Badge>
                    </div>)}
                </div>
                <Button variant="outline" className="w-full" onClick={() => setMfaDialogOpen(true)} data-id="element-3309">
                  + Daftarkan Perangkat Baru
                </Button>
              </CardContent>
            </Card>
          </div>

          <Dialog open={mfaDialogOpen} onOpenChange={setMfaDialogOpen} data-id="element-3310">
            <DialogContent className="max-w-md" data-id="element-3311">
              <DialogHeader data-id="element-3312">
                <DialogTitle data-id="element-3313">Daftarkan Perangkat MFA Baru</DialogTitle>
                <DialogDescription data-id="element-3314">
                  Pilih jenis perangkat MFA yang ingin Anda daftarkan.
                </DialogDescription>
              </DialogHeader>
              <div className="space-y-4" data-id="element-3315">
                <div className="grid grid-cols-1 gap-3" data-id="element-3316">
                  <label className="flex items-center gap-3 p-3 rounded-lg border border-border/50 bg-muted/20 hover:bg-muted/40 cursor-pointer" data-id="element-3317">
                    <Checkbox checked={mfaDeviceType === 'hardware'} onCheckedChange={v => setMfaDeviceType('hardware')} className="mt-0.5" data-id="element-3318" />
                    <div data-id="element-3319">
                      <p className="text-sm font-medium" data-id="element-3320">Hardware Token</p>
                      <p className="text-xs text-muted-foreground" data-id="element-3321">
                        YubiKey, Titan, atau perangkat serupa
                      </p>
                    </div>
                  </label>
                  <label className="flex items-center gap-3 p-3 rounded-lg border border-border/50 bg-muted/20 hover:bg-muted/40 cursor-pointer" data-id="element-3322">
                    <Checkbox checked={mfaDeviceType === 'authenticator'} onCheckedChange={v => setMfaDeviceType('authenticator')} className="mt-0.5" data-id="element-3323" />
                    <div data-id="element-3324">
                      <p className="text-sm font-medium" data-id="element-3325">Authenticator App</p>
                      <p className="text-xs text-muted-foreground" data-id="element-3326">
                        Google Authenticator, Authy, atau aplikasi serupa
                      </p>
                    </div>
                  </label>
                  <label className="flex items-center gap-3 p-3 rounded-lg border border-border/50 bg-muted/20 hover:bg-muted/40 cursor-pointer" data-id="element-3327">
                    <Checkbox checked={mfaDeviceType === 'sms'} onCheckedChange={v => setMfaDeviceType('sms')} className="mt-0.5" data-id="element-3328" />
                    <div data-id="element-3329">
                      <p className="text-sm font-medium" data-id="element-3330">SMS Backup</p>
                      <p className="text-xs text-muted-foreground" data-id="element-3331">
                        Pesan SMS ke nomor yang terdaftar
                      </p>
                    </div>
                  </label>
                </div>
                <div className="flex gap-3" data-id="element-3332">
                  <Input type="text" placeholder="Kode verifikasi 6 digit" value={mfaCode} onChange={e => setMfaCode(e.target.value)} className="flex-1" data-id="element-3333" />
                  <Button onClick={handleVerifyMfa} disabled={mfaCode.length !== 6} data-id="element-3334">
                    <Save className="size-4 mr-1.5" data-id="element-3335" /> Verifikasi
                  </Button>
                </div>
              </div>
              <DialogFooter data-id="element-3336">
                <Button variant="outline" onClick={() => setMfaDialogOpen(false)} data-id="element-3337">
                  Batal
                </Button>
              </DialogFooter>
            </DialogContent>
          </Dialog>
        </TabsContent>

        {/* APPEARANCE */}
        <TabsContent value="appearance" className="mt-4" data-id="element-3338">
          <Card className="bg-card border-border/50" data-id="element-3339">
            <CardContent className="p-6 space-y-5" data-id="element-3340">
              <div data-id="element-3341">
                <h3 className="font-heading text-base font-bold flex items-center gap-2" data-id="element-3342">
                  <Palette className="size-4 text-primary" data-id="element-3343" /> Preferensi
                  Tampilan
                </h3>
                <p className="text-xs text-muted-foreground mt-0.5" data-id="element-3344">
                  Sesuaikan kepadatan, refresh rate, dan opsi visual.
                </p>
              </div>
              <Separator data-id="element-3345" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-3346">
                <div data-id="element-3347">
                  <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3348">
                    Kepadatan Tampilan
                  </Label>
                  <Select value={density} onValueChange={setDensity} data-id="element-3349">
                    <SelectTrigger className="mt-1.5" data-id="element-3350">
                      <SelectValue data-id="element-3351" />
                    </SelectTrigger>
                    <SelectContent data-id="element-3352">
                      <SelectItem value="comfortable" data-id="element-3353">Nyaman</SelectItem>
                      <SelectItem value="compact" data-id="element-3354">Padat</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div data-id="element-3355">
                  <Label className="text-xs font-mono uppercase text-muted-foreground" data-id="element-3356">
                    Auto-Refresh Data
                  </Label>
                  <Select value={autoRefresh} onValueChange={setAutoRefresh} data-id="element-3357">
                    <SelectTrigger className="mt-1.5" data-id="element-3358">
                      <SelectValue data-id="element-3359" />
                    </SelectTrigger>
                    <SelectContent data-id="element-3360">
                      <SelectItem value="off" data-id="element-3361">Mati</SelectItem>
                      <SelectItem value="15" data-id="element-3362">Tiap 15 detik</SelectItem>
                      <SelectItem value="30" data-id="element-3363">Tiap 30 detik</SelectItem>
                      <SelectItem value="60" data-id="element-3364">Tiap 1 menit</SelectItem>
                      <SelectItem value="300" data-id="element-3365">Tiap 5 menit</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <div className="flex justify-end" data-id="element-3366">
                <Button onClick={() => save('tampilan')} data-id="element-3367">
                  <Save className="size-4 mr-1.5" data-id="element-3368" /> Simpan Tampilan
                </Button>
              </div>
            </CardContent>
          </Card>
        </TabsContent>

        {/* DATA SOURCES */}
        <TabsContent value="data" className="mt-4" data-id="element-3369">
          <Card className="bg-card border-border/50" data-id="element-3370">
            <CardContent className="p-6 space-y-5" data-id="element-3371">
              <div data-id="element-3372">
                <h3 className="font-heading text-base font-bold flex items-center gap-2" data-id="element-3373">
                  <Database className="size-4 text-primary" data-id="element-3374" /> Sumber Data &
                  Integrasi
                </h3>
                <p className="text-xs text-muted-foreground mt-0.5" data-id="element-3375">
                  Konektor aktif dengan platform dan lembaga eksternal.
                </p>
              </div>
              <Separator data-id="element-3376" />
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-3" data-id="element-3377">
                {[{
                name: 'Meta Platforms (FB/IG)',
                status: 'AKTIF',
                latency: '120ms'
              }, {
                name: 'X (Twitter) API v2',
                status: 'AKTIF',
                latency: '95ms'
              }, {
                name: 'TikTok Research API',
                status: 'AKTIF',
                latency: '180ms'
              }, {
                name: 'YouTube Data API',
                status: 'AKTIF',
                latency: '110ms'
              }, {
                name: 'Telegram Channels',
                status: 'AKTIF',
                latency: '210ms'
              }, {
                name: 'BSSN Threat Feed',
                status: 'AKTIF',
                latency: '45ms'
              }, {
                name: 'BIN Intel Pipeline',
                status: 'AKTIF',
                latency: '60ms'
              }, {
                name: 'Lapor.go.id',
                status: 'STANDBY',
                latency: '—'
              }].map(c => <div key={c.name} className="flex items-center justify-between p-3 rounded-lg border border-border/50 bg-muted/20" data-id="element-3378">
                    <div data-id="element-3379">
                      <p className="text-sm font-medium" data-id="element-3380">{c.name}</p>
                      <p className="font-mono text-[10px] text-muted-foreground" data-id="element-3381">
                        Latency: {c.latency}
                      </p>
                    </div>
                    <Badge variant="outline" className={c.status === 'AKTIF' ? 'bg-emerald-50 text-emerald-700 border-emerald-200 font-mono text-[10px]' : 'bg-amber-50 text-amber-700 border-amber-200 font-mono text-[10px]'} data-id="element-3382">
                      {c.status}
                    </Badge>
                  </div>)}
              </div>
            </CardContent>
          </Card>
        </TabsContent>
      </Tabs>
    </div>;
}